import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  userName = "User, name";
  menuTitle: string = "Workers' Compensation Exemption"
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  gotoErrorTest(): void {
    this.router.navigate(['error/test'])
  }

}
